interface IResourceLink {
    name: string;
    href: string;
}

const resourceLinksByLanguage: Record<string, Array<IResourceLink>> = {
    en: [
        {
            name: 'MRS Field Glossary',
            href: 'https://phoenixmrsprod.blob.core.windows.net/training/en/MRS%20Fields%20Glossary.pdf',
        },
        {
            name: 'MRS Training Document',
            href: 'https://phoenixmrsprod.blob.core.windows.net/training/en/Phoenix%20Loss%20Control%20-%20Guide%20To%20MRS.pdf',
        },
        { name: 'MRS Training Video', href: 'https://www.youtube.com/watch?v=KuDd7u7dOjU&t=14s' },
        {
            name: 'Pre-Dig Training Document',
            href: 'https://phoenixmrsprod.blob.core.windows.net/training/en/Phoenix%20Loss%20Control%20-%20Pre-Dig%20Training.pdf',
        },
        { name: 'Pre-Dig Training Video', href: 'https://www.youtube.com/watch?v=H6DbvEfiKAc' },
        {
            name: 'Reporting Damages Training Document',
            href: 'https://phoenixmrsprod.blob.core.windows.net/training/en/Phoenix%20Loss%20Control%20-%20Reporting%20Damages%20Training.pdf',
        },
        { name: 'Reporting Damages Training Video', href: 'https://www.youtube.com/watch?v=etupM5jNBCA' },
    ],
    fr: [
        {
            name: 'Glossaire MRS',
            href: 'https://phoenixmrsprod.blob.core.windows.net/training/fr/MRS%20Fields%20Glossary.pdf',
        },
        {
            name: 'Document de Formation MRS',
            href: 'https://phoenixmrsprod.blob.core.windows.net/training/fr/Phoenix%20Loss%20Control%20-%20Guide%20To%20MRS.pdf',
        },
        { name: 'Vidéo de Formation MRS', href: 'https://www.youtube.com/watch?v=KuDd7u7dOjU&t=14s' },
        {
            name: 'Document de Formation Pré-Dig',
            href: 'https://phoenixmrsprod.blob.core.windows.net/training/fr/Phoenix%20Loss%20Control%20-%20Pre-Dig%20Training.pdf',
        },
        { name: 'Vidéo de Formation Pré-Dig', href: 'https://www.youtube.com/watch?v=H6DbvEfiKAc' },
        {
            name: 'Document de Formation sur le Signalement des Dommages',
            href: 'https://phoenixmrsprod.blob.core.windows.net/training/fr/Phoenix%20Loss%20Control%20-%20Reporting%20Damages%20Training.pdf',
        },
        {
            name: 'Vidéo de Formation sur le Signalement des Dommages',
            href: 'https://www.youtube.com/watch?v=etupM5jNBCA',
        },
    ],
};

export const getResourceLinks = (selectedLanguage: string): Array<IResourceLink> => {
    return resourceLinksByLanguage[selectedLanguage] || resourceLinksByLanguage['en'];
};
